import { URL_ORIGIN } from "../data/constants/urls";

export default function getUrlFromLocation({ pathname, search }) {
  return URL_ORIGIN + pathname + search;
}
